<template>
  <page no-styling>
    <template #navigation_action>
      <div style="height: 100%; display: contents">
        <icon
          v-if="!isAddingCoupon"
          plus
          :size="24"
          class="mya"
          name="addnewcoupon"
          @click="addCoupon"
        />

        <icon
          v-else-if="coupons.length !== 1"
          class="mya"
          @click="deleteNewCoupon()"
          cancel
        />
      </div>
    </template>

    <div class="flex column">
      <div
        v-for="(c, n) in coupons"
        :key="`${n}coupon`"
        :style="`order: ${coupons.length - n};`"
      >
        <edit-coupon
          v-model="coupons[n]"
          class="card pa0"
        />

        <div class="card-spacing" />

      </div>
    </div>
  </page>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import CarouselMixin from '@/mixins/carousel_mixin';
import EditCoupon from '@/components/EditCoupon.vue';
import { isIdNew, generateId } from '@/utils/id_utils';

export default {
  name: 'edit-coupons',

  mixins: [CarouselMixin],

  components: {
    EditCoupon,
  },

  data() {
    return {
      coupons: [],
    };
  },

  props: {
    campaign: Object,
  },

  created() {
    this.coupons = cloneDeep(this.campaign.coupons);

    if (this.coupons.length === 0) {
      this.addCoupon();
    }
  },

  computed: {
    isAddingCoupon() {
      return !!this.coupons.find(c => c && isIdNew(c.id));
    },
  },

  methods: {
    deleteNewCoupon() {
      this.$bus.$emit('delete-new-coupon');

      // after timeout for animation
      setTimeout(() => {
        const index = this.coupons.findIndex(coupon => isIdNew(coupon.id));
        this.coupons.splice(index, 1);
      }, 250);
    },

    addCoupon() {
      const id = generateId(true);
      this.coupons.push(Object.assign({}, this.$MODELS.coupon, { id }));
    },
  },
};
</script>
